<template>
    <DashboardContentLayout class="space-y-8" :heading="$t('views.feed.rawMaterials.header.heading')" :has-period-picker="false" :has-pig-type-picker="false">
        <RawMaterialsTable></RawMaterialsTable>
    </DashboardContentLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import RawMaterialsTable from '@/views/dashboard/feed/feedRawMaterials/RawMaterialsTable.vue';

export default defineComponent({
    components: { DashboardContentLayout, RawMaterialsTable },
});
</script>
